const canonicalUrl = (slug, lang) => {
    // If page in en-US returns only the slug otherwise /$localLang/slug except where the slug for index should not be set
    let localSlug = '/'
    let languageSlug = ''
  
    if (slug != 'index' && slug != '' && slug) {
      localSlug = `/${slug}/`
    }
    if (lang === 'en-US') {
        languageSlug = ''
    } else {
      languageSlug = `/${lang.toLowerCase()}`
    }
    return (
      `${languageSlug}${localSlug}`
    )
  }
  

  export default canonicalUrl;